
// Actions
import { createSlice } from '@reduxjs/toolkit';
export const namespace = 'containers/TrendingStoriesOverview';

export const initialState = {
  isOpen: false,
  story: null,
  profileId: null,
  startTime: null,
  endTime: null,
  shortDateString: null,
  storyDetails: null,
  analytics: null,
  loadOverviewError: null,
  loadAnalyticsError: null,
  tweetsLoading: false,
  tweets: {},
  tweetsLoadError: null,
  currentViewIndex: 0,
  isTwitterRestricted: false,
};

const trendingStoriesOverviewSlice = createSlice({
  name: 'containers/TrendingStoriesOverview',
  initialState,
  reducers: {
    handleOpen: (state, { payload: { story, profileId, startTime, endTime, shortDateString, isTwitterRestricted } }) =>
      ({ ...initialState, isOpen: true, story, profileId, startTime, endTime, shortDateString, isTwitterRestricted }),
    handleClose: () => ({...initialState}),
    // for the overview page
    setStoryDetails: (state, { payload }) => ({ ...state, storyDetails: payload }),
    setAnalytics: (state, { payload }) => {
      state.analytics = payload;
    },
    loadOverviewError: (state, { payload }) => ({ ...state, loadOverviewError: payload }),
    loadAnalyticsError: (state, { payload }) => ({ ...state, loadAnalyticsError: payload }),
    // for the tweets page
    setTweets: (state, { payload }) => ({ ...state, tweetsLoading: false, tweets: payload }),
    loadTweets: (state) => ({ ...state, tweetsLoading: true, tweetsLoadError: null }),
    loadTweetsError: (state, { payload }) => ({ ...state, tweetsLoading: false, tweetsLoadError: payload}),
    setCurrentViewIndex: (state, { payload }) => ({ ...state, currentViewIndex: payload })
  }
});

const { actions, reducer } = trendingStoriesOverviewSlice;
export default reducer;
export const {
  handleOpen,
  handleClose,
  setStoryDetails,
  setAnalytics,
  loadAnalyticsError,
  loadOverviewError,
  setTweets,
  loadTweetsError,
  loadTweets,
  setCurrentViewIndex,
} = actions;

